export interface DorpelType {
  dorpel: string;
  merk: string;
  zaagmaat: number;
  aantalNeuten: number;
  aantalSluitpotten: number;
  schema: string;
  deurmaatA?: number;
  deurmaatB?: number;
  deurmaatC?: number;
  firstMaatA?: number;
  maatA?: number;
  maatB?: number;
  maatC?: number;
  maatZ?: number;
  opmerking?: string;
  aantal?: number;
}

const DORPEL_CODES = {
  BINNEN_DORPEL: "BI",
  BUITEN_DORPEL: "BU",
  HEFSCHUIF_DORPEL: "HS"
};

export class DorpelUtils {
  public static getThicknessFromDorpelCode(dorpelCode: string): number {
    let size = dorpelCode.split(".")[1];
    if (DorpelUtils.isSlidingDoor(dorpelCode)) {
      return parseInt(size);
    }

    let heightAboveDam = size.slice(0,2);
    let heightBelowDam = size.slice(2);
    return parseInt(heightAboveDam) + parseInt(heightBelowDam);
  }

  public static getDamLevelFromDorpelCode(dorpelCode: string): number {
    let dorpelSplitDimensions = dorpelCode.split(".")[1];
    let damLevel = dorpelSplitDimensions ? parseInt(dorpelSplitDimensions.substr(0,2)) : 0;
    return damLevel;
  }

  public static isSlidingDoor(dorpelCode: string): boolean {
    return dorpelCode.indexOf(DORPEL_CODES.HEFSCHUIF_DORPEL) !== -1
  }

  public static isBinnenDoor(dorpelCode: string): boolean {
    return dorpelCode.indexOf(DORPEL_CODES.BINNEN_DORPEL) !== -1
  }

  public static isBuitenDoor(dorpelCode: string): boolean {
    return dorpelCode.indexOf(DORPEL_CODES.BUITEN_DORPEL) !== -1
  }
}